export function BrandMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" focusable="false" className={className}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 0H26A6 6 0 0 1 32 6V26A6 6 0 0 1 26 32H6A6 6 0 0 1 0 26V6A6 6 0 0 1 6 0Z M7 23V9h3.6l5.4 8.2L21.4 9H25v14h-3.4v-8.4L17 21h-2l-4.6-6.4V23H7Z"
      />
    </svg>
  )
}
